import $ from 'jquery';

import { getBusinessSearchUrl, getDefaultPageSize } from 'chairisher/context/search';

/**
 * @class BusinessSearchView
 * @classdesc Handles searching for businesses
 * @constructor
 */
const BusinessSearchView = function () {
    this._$searchForm = $(this._searchFormSelector);
    this._facets = this._buildFacets();
};

/**
 * FacetNames for this search view.
 *
 * @type {Array.<string>}
 */
BusinessSearchView.FacetNames = ['location', 'page_size', 'sort', 'specialization'];

/**
 * @type {jQuery}
 * @private
 */
BusinessSearchView.prototype._$searchForm = null;

/**
 * @type {string}
 * @private
 */
BusinessSearchView.prototype._eventNameSpace = 'businessSearch';

/**
 * @type {Object.<string, jQuery>}
 * @private
 */
BusinessSearchView.prototype._facets = null;

/**
 * @type {string}
 * @default
 * @private
 */
BusinessSearchView.prototype._searchFormSelector = '.js-business-search-form';

/**
 * Build the facets which control input to this view.
 *
 * @return {jQuery}
 * @private
 */
BusinessSearchView.prototype._buildFacets = function () {
    const facetNames = BusinessSearchView.FacetNames;
    const facets = {};

    for (let i = 0; i < facetNames.length; i++) {
        facets[facetNames[i]] = $(`[name=${facetNames[i]}]`);
    }

    return facets;
};

/**
 * Construct a search object from the current state of the view.
 *
 * @return {Object.<string, string>}
 * @private
 */
BusinessSearchView.prototype._buildSearch = function () {
    const search = {};

    $.each(this._facets, (field, $el) => {
        if (
            $el.val() &&
            // Special handling for page_size
            (field !== 'page_size' || parseInt($el.val(), 10) !== getDefaultPageSize())
        ) {
            search[field] = $el.val();
        }
    });

    return search;
};

/**
 * @param {string} eventName The name of the event to namespace
 * @returns {string} The namespaced event
 * @private
 */
BusinessSearchView.prototype._nameSpacedEvent = function (eventName) {
    return [this._eventNameSpace, eventName].join('.');
};

/**
 * Trigger an event.
 *
 * @param event {Event} Base event which is cloned into the triggered event
 * @param type {string} Type of event to trigger
 * @param opt_data {Object=} Optional data to pass along with the event
 * @private
 */
BusinessSearchView.prototype._trigger = function (event, type, opt_data) {
    const newEvent = $.extend({}, event); // clone so we don't modify the original event object
    type = this._nameSpacedEvent(type);
    newEvent.type = type;
    event = $.Event(type, newEvent);

    this.getSearchForm().trigger(event, opt_data);
};

/**
 * Get the search form.
 *
 * @return {jQuery}
 */
BusinessSearchView.prototype.getSearchForm = function () {
    return this._$searchForm;
};

/**
 * Bind the search view.
 */
BusinessSearchView.prototype.bind = function () {
    const $searchForm = this._$searchForm;

    const submit = $.proxy(function (e) {
        e.preventDefault();
        const search = this._buildSearch();
        let url = getBusinessSearchUrl();
        const params = $.param(search);
        if (params) {
            url += `?${params}`;
        }
        this._trigger(e, 'submit', {
            url,
            search,
        });
    }, this);

    $searchForm.on('submit', submit);
    this._facets.page_size.on('change', submit);
    this._facets.sort.on('change', submit);
};

export default BusinessSearchView;
